/**
 * Name of the invisible "honeypot" field rendered on bot-protected forms.
 *
 * Genuine users never populate it — it is off-screen, keyboard-unreachable and
 * hidden from assistive tech. Automated form fillers populate every input they
 * find in the DOM, so a non-empty value marks the submission as bot traffic.
 *
 * The name must look like an ordinary optional field: anything self-describing
 * (`honeypot`, `bot_field`) lets smarter bots skip it. It must also match no
 * HTML autocomplete token, otherwise browsers and password managers fill it and
 * flag real users as bots.
 *
 * Must stay in sync with `HONEYPOT_FIELD` in gg-backend-v2.
 */
export const HONEYPOT_FIELD_NAME = 'referralCode';
